// extracted by mini-css-extract-plugin
module.exports = {"list":"upsNr","link":"i2lkE","title":"Soj7A","item":"_0Psgr","active":"_2Bg2K","subtitle":"OLIPK","card":"KPpbZ","withCard":"lCN3k","type_mobile":"J4Eo0"};